import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Tag} from 'yougile-model'
import {Icon} from '@components/common/base/icon'
import {UserName} from '@components/user-name'
import {useMyStickersStore} from '../../../my-stickers-store'

const TwUser = tw.div`
  pl-24
  flex
  items-center
  gap-2
  truncate
  text-xs-regular
  text-secondary
`

export const ListItemUser = observer(({sticker}: {sticker: Tag}) => {
  const [state] = useMyStickersStore()

  if (sticker.data.by) {
    return (
      <TwUser>
        <Icon icon="IconUserCircle" />
        <UserName
          userId={sticker.data.by}
          highlight={state.searchQuery}
          className="truncate"
          preTitle={Lang.msg.myStickers.infoUser}
        />
      </TwUser>
    )
  }
  return null
})
